import { defaultRtoState } from '../contexts/RTOSuiteProvider'
import { SplitCodType, SplitCodConfigType, SplitCodSlabType, SplitCODPayload } from '../types/rtoSuite'

export const mapSplitCodResponseToConfig = (data?: SplitCodType): SplitCodConfigType => {
  if (!data)
    return {
      isEnabled: false,
      slabs: defaultRtoState?.splitCodConfig?.slabs ?? []
    }
  return {
    isEnabled: data?.enable ?? false,
    slabs:
      data?.slabs?.map(slab => ({
        minOrderValue: slab?.min_payment_value,
        maxOrderValue: slab?.max_payment_value,
        prepaidShare: slab?.prepaid_share,
        prepaidShareType: slab?.prepaid_share_type,
        isCODChargesExcluded: slab?.exclude_cod_charges
      })) || defaultRtoState?.splitCodConfig?.slabs
  }
}

export const mapFormSlabsToConfigSlabs = (slabs: SplitCodSlabType[]): SplitCodSlabType[] => {
  return slabs.map(slab => ({
    minOrderValue: slab.minOrderValue,
    maxOrderValue: slab.maxOrderValue ?? null,
    prepaidShare: slab.prepaidShare,
    prepaidShareType: slab.prepaidShareType,
    isCODChargesExcluded: slab.isCODChargesExcluded ?? false
  }))
}

export const getSplitCodPayload = (isEnabled: boolean, slabs: SplitCodSlabType[]): SplitCODPayload => {
  return {
    enable: isEnabled,
    slabs: slabs.map(slab => ({
      min_payment_value: slab.minOrderValue,
      max_payment_value: slab.maxOrderValue,
      prepaid_share: slab.prepaidShare,
      prepaid_share_type: slab.prepaidShareType,
      exclude_cod_charges: slab.isCODChargesExcluded
    }))
  }
}
